class CartLuckyTheme{
  constructor(){this.cart=document.querySelector('[data-cart-drawer]');this.search=document.querySelector('[data-search-overlay]');this.menu=document.querySelector('[data-mobile-menu]');this.bind()}
  bind(){
    document.addEventListener('click',e=>{
      const openCart=e.target.closest('[data-open-cart]'); const closeCart=e.target.closest('[data-close-cart]');
      const openSearch=e.target.closest('[data-open-search]'); const closeSearch=e.target.closest('[data-close-search]');
      const openMenu=e.target.closest('[data-open-menu]'); const closeMenu=e.target.closest('[data-close-menu]');
      const q=e.target.closest('[data-quantity]'); const grid=e.target.closest('[data-grid-cols]');
      const cartQty=e.target.closest('[data-cart-quantity]'); const cartRemove=e.target.closest('[data-cart-remove]');
      if(openCart){e.preventDefault();this.open(this.cart)} if(closeCart)this.close(this.cart);
      if(openSearch){e.preventDefault();this.open(this.search)} if(closeSearch)this.close(this.search);
      if(openMenu)this.open(this.menu); if(closeMenu)this.close(this.menu);
      if(q){const input=q.parentElement.querySelector('input');input.value=Math.max(1,Number(input.value)+(q.dataset.quantity==='plus'?1:-1))}
      if(cartQty){e.preventDefault();this.adjustCartQuantity(cartQty)}
      if(cartRemove){e.preventDefault();this.changeCartLine(cartRemove.dataset.lineKey,0,cartRemove)}
      if(grid){document.querySelectorAll('[data-grid-cols]').forEach(b=>b.classList.remove('is-active'));grid.classList.add('is-active');const target=document.querySelector('[data-product-grid]');if(target){target.classList.remove('grid-2','grid-3','grid-4');target.classList.add('grid-'+grid.dataset.gridCols)}}
    });
    document.addEventListener('submit',async e=>{
      const form=e.target.closest('[data-product-form],[data-quick-add]'); if(!form)return;
      e.preventDefault(); const button=form.querySelector('[type=submit]'); if(button)button.disabled=true;
      try{await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});await this.refreshCart();this.open(this.cart)}
      catch(err){console.error(err)}finally{if(button)button.disabled=false}
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){this.close(this.cart);this.close(this.search);this.close(this.menu)}})
  }
  open(el){if(!el)return;el.classList.add('is-open');el.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';el.querySelector('button,input,a')?.focus()}
  close(el){if(!el)return;el.classList.remove('is-open');el.setAttribute('aria-hidden','true');document.body.style.overflow=''}
  setCartBusy(isBusy){
    if(!this.cart)return;
    this.cart.classList.toggle('is-updating',isBusy);
    this.cart.querySelectorAll('[data-cart-quantity],[data-cart-remove],.cart-drawer__checkout').forEach(el=>el.disabled=isBusy);
  }
  adjustCartQuantity(button){
    const item=button.closest('[data-cart-item]');
    const value=Number(item?.querySelector('[data-cart-quantity-value]')?.textContent||1);
    const next=Math.max(0,value+(button.dataset.cartQuantity==='plus'?1:-1));
    this.changeCartLine(button.dataset.lineKey,next,button);
  }
  async changeCartLine(key,quantity,source){
    if(!key||this.cart?.classList.contains('is-updating'))return;
    this.setCartBusy(true);
    source?.closest('[data-cart-item]')?.classList.add('is-changing');
    try{
      const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
      if(!response.ok)throw new Error('Unable to update cart');
      const cart=await response.json();
      await this.refreshCart(true,cart.item_count);
    }catch(err){console.error(err);this.setCartBusy(false)}
  }
  async refreshCart(keepOpen=false,knownCount=null){
    const wasOpen=keepOpen||this.cart?.classList.contains('is-open');
    const html=await fetch('/?section_id=cart-drawer',{headers:{'Accept':'text/html'}}).then(r=>r.text());
    const doc=new DOMParser().parseFromString(html,'text/html');
    const next=doc.querySelector('[data-cart-drawer]');
    if(next&&this.cart){
      if(wasOpen){next.classList.add('is-open');next.setAttribute('aria-hidden','false')}
      this.cart.replaceWith(next);this.cart=next;
      if(wasOpen)document.body.style.overflow='hidden';
    }
    const count=knownCount!==null?knownCount:await fetch('/cart.js').then(r=>r.json()).then(c=>c.item_count).catch(()=>null);
    if(count!==null)document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=count;el.classList.remove('is-cart-pop');void el.offsetWidth;el.classList.add('is-cart-pop');window.setTimeout(()=>el.classList.remove('is-cart-pop'),650)});
  }
}
customElements.define('predictive-search',class extends HTMLElement{connectedCallback(){this.input=this.querySelector('input');this.results=this.querySelector('[data-predictive-results]');this.input?.addEventListener('input',()=>this.search())}async search(){const q=this.input.value.trim();if(q.length<2){this.results.innerHTML='';return}const html=await fetch('/search/suggest?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&section_id=predictive-search').then(r=>r.text());this.results.innerHTML=html}});
document.addEventListener('DOMContentLoaded',()=>new CartLuckyTheme());


function initProductMediaSwitchers(){
  document.querySelectorAll('[data-product-media-switcher]').forEach(gallery=>{
    if(gallery.dataset.ready==='true')return;
    gallery.dataset.ready='true';

    const track=gallery.querySelector('[data-product-gallery-track]');
    const stage=gallery.querySelector('[data-product-gallery-stage]');
    const slides=[...gallery.querySelectorAll('[data-product-gallery-slide]')];
    const thumbs=[...gallery.querySelectorAll('[data-product-gallery-thumb]')];
    const prev=gallery.querySelector('[data-product-gallery-prev]');
    const next=gallery.querySelector('[data-product-gallery-next]');
    if(!track||!stage||slides.length<2||thumbs.length<2)return;

    let index=0;
    let pointerId=null;
    let startX=0;
    let deltaX=0;
    let dragging=false;

    const pulse=thumb=>{
      if(!thumb)return;
      thumb.classList.remove('is-pulsing');
      void thumb.offsetWidth;
      thumb.classList.add('is-pulsing');
      window.setTimeout(()=>thumb.classList.remove('is-pulsing'),360);
    };

    const render=(animate=true,focusThumb=false,withPulse=true)=>{
      track.classList.toggle('is-dragging',!animate);
      track.style.transform=`translate3d(${-index*100}%,0,0)`;
      slides.forEach((slide,i)=>slide.setAttribute('aria-hidden',i===index?'false':'true'));
      thumbs.forEach((thumb,i)=>{
        const active=i===index;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-pressed',active?'true':'false');
      });
      const activeThumb=thumbs[index];
      if(withPulse)pulse(activeThumb);
      if(focusThumb)activeThumb?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    };

    const select=(nextIndex,focusThumb=false)=>{
      index=(nextIndex+slides.length)%slides.length;
      render(true,focusThumb,true);
    };

    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>{
      if(i===index){pulse(thumb);return;}
      select(i,false);
    }));
    prev?.addEventListener('click',()=>select(index-1,true));
    next?.addEventListener('click',()=>select(index+1,true));

    stage.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse'&&e.button!==0)return;
      if(e.target.closest('button'))return;
      pointerId=e.pointerId;
      startX=e.clientX;
      deltaX=0;
      dragging=true;
      stage.setPointerCapture?.(pointerId);
      track.classList.add('is-dragging');
    });

    stage.addEventListener('pointermove',e=>{
      if(!dragging||e.pointerId!==pointerId)return;
      deltaX=e.clientX-startX;
      const width=stage.clientWidth||1;
      const base=-index*width;
      const resistance=(index===0&&deltaX>0)||(index===slides.length-1&&deltaX<0)?0.35:1;
      track.style.transform=`translate3d(${base+deltaX*resistance}px,0,0)`;
    });

    const finishDrag=e=>{
      if(!dragging||e.pointerId!==pointerId)return;
      dragging=false;
      stage.releasePointerCapture?.(pointerId);
      const threshold=Math.max(42,stage.clientWidth*.12);
      if(Math.abs(deltaX)>=threshold){
        if(deltaX<0&&index<slides.length-1)index+=1;
        else if(deltaX>0&&index>0)index-=1;
      }
      deltaX=0;
      pointerId=null;
      render(true,true,true);
    };

    stage.addEventListener('pointerup',finishDrag);
    stage.addEventListener('pointercancel',finishDrag);
    stage.addEventListener('lostpointercapture',e=>{
      if(dragging&&e.pointerId===pointerId)finishDrag(e);
    });

    render(false,false,false);
    requestAnimationFrame(()=>track.classList.remove('is-dragging'));
  });
}

document.addEventListener('DOMContentLoaded',initProductMediaSwitchers);

/* CartLucky cart-count microinteraction */
